import { SchedulerClasses, SchedulerLocaleLabels, SchedulerResourceHeaderClasses } from "./scheduler.js";
import { Helper as GlobalHelper } from "../core/util/helper.js";
import { Config } from "../core/config/config.js";
import {
    AssignmentType,
    GetRosterInfoFromArray,
    IsEventType,
    ResourcePlanningSchedulerCapacitySettings,
    ResourcePlanningSchedulerEventViewModel,
    ResourcePlanningSchedulerResourceViewModel,
    ResourcePlanningSchedulerSettingsPlanningBoardViewModel, RosterDayInfoViewModel
} from "./resourcePlanningScheduler.js";
import WorkbookSheetColumn = kendo.ooxml.WorkbookSheetColumn;
import WorkbookSheetRow = kendo.ooxml.WorkbookSheetRow;
import WorkbookSheetRowCell = kendo.ooxml.WorkbookSheetRowCell;
import { AssignmentTimesModel, JourneyLegModel, TraveldataInfoModel } from "../resourcePlanning/resourcePlanning.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
export class Diagram extends React.Component<CapacityDiagramProps, CapacityDiagramState> {
    private _barWrapperRef: HTMLDivElement = null;
    private _paddingFillerRef: HTMLDivElement = null;
    private _icuh = GlobalHelper;
    private _diagramInfo: Info = null;
    private _computation: Computation = new Computation();
    private _selectedResources: Array<string> = [];
    private _propsData: CapacityDiagramPropsData = null;
    private _refreshMode: CapacityRefreshMode = null; //CapacityRefreshMode.Reload;
    private _awaitTrigger = false;
    private _diagramWillShow = false;
    private _afterComputationData = {
        stats: {
            resources: 0,
            containers: 0
        },
        counts: {
            resources: 0,
            containers: 0
        },
        marks: {
            fifty: 0,
            hundred: 0
        }
    };
    private _considerHiddenAssignments = false;
    private _resizeHandlerSet = false;


    constructor(props: CapacityDiagramProps) {
        super(props);
        this.state = {
            showPopUp: false
        };
        this._prepareData();
    }

    private _renderColumns = () => {
        const result = [];

        for (let i = 0; i < this._getNumberOfColumns(); i++) {
            const cd = this._getColumnData(i);
            const values = this._computation.getComputedValues(i);
            const overload = GlobalHelper.hasValue(values.raw) && values.raw.overload >= 0 ? values.raw.overload : 0;
            const absent = GlobalHelper.hasValue(values.raw) && values.raw.absent >= 0 ? values.raw.absent : 0;
            const external = GlobalHelper.hasValue(values.raw) && values.raw.external >= 0 ? values.raw.external : 0;
            const assignment = GlobalHelper.hasValue(values.raw) && values.raw.assignment >= 0 ? values.raw.assignment : 0;
            const intern = GlobalHelper.hasValue(values.raw) && values.raw.intern >= 0 ? values.raw.intern : 0;


            result.push(
                <div className="capacity-diagram__bar" key={i} style={{ width: this._propsData.scheduler.cellWidth }} onMouseMove={ev => this._onMouseEnter(ev, cd.date, values.raw)}>
                    <div className="capacity-diagram__bar__header">{cd.header}</div>
                    <div className={"capacity-diagram__bar__values " + (cd.isWeekend ? SchedulerClasses.WeekEnd : null)} style={{ overflow: "hidden" }}>
                        <div className={CapacityColorClasses.Internal} style={{ flexBasis: intern * 0.8 + "%", flexShrink: 0 }} />
                        <div className={CapacityColorClasses.Overload} style={{ flexBasis: overload * 0.8 + "%", flexShrink: 0 }} />
                        <div className={CapacityColorClasses.Absent} style={{ flexBasis: absent * 0.8 + "%", flexShrink: 0 }} />
                        <div className={CapacityColorClasses.External} style={{ flexBasis: external * 0.8 + "%", flexShrink: 0 }} />
                        <div className={CapacityColorClasses.Assignment} style={{ flexBasis: assignment * 0.8 + "%", flexShrink: 0 }} />
                    </div>
                </div>
            );
        }

        return result;
    }

    private _getNumberOfColumns = () => {
        switch (this._propsData.scale) {
            case "Day": return this._propsData.scheduler.days;
            case "Week": return Math.ceil(this._propsData.scheduler.days / 7);
            case "Month": return Helper.getMonthsOffset(this._propsData.startDate, this._icuh.dates.addDays(this._propsData.startDate, this._propsData.scheduler.days));
            default: return 0;
        }
    }

    private _getColumnData = (idx: number) => {
        let columnData = {
            header: "",
            isWeekend: false,
            date: null as Date
        };

        switch (this._propsData.scale) {
            case "Day":
                const d = this._icuh.dates.addDays(this._propsData.startDate, idx);
                columnData.header = d.getDate().toString();
                columnData.date = d;
                columnData.isWeekend = d.getDay() === 0 || d.getDay() === 6;
                break;
            case "Week":
                const dpd = new DayPilot.Date(this._propsData.startDate, true).addDays(idx * 7);
                columnData.header = dpd.weekNumberISO().toString();
                columnData.date = dpd.toDateLocal();
                break;
            case "Month":
                const dm = new DayPilot.Date(this._propsData.startDate, true).addMonths(idx);
                columnData.header = SchedulerLocaleLabels[Config.user.languageId === 0 ? "de-de" : "en-gb"].monthsShort[dm.getMonth()];
                columnData.date = dm.toDateLocal();
                break;
            default: break;
        }

        return columnData;
    }

    private _updateInfoPosition = (props: DiagramInfoState) => {
        if (this._diagramInfo != null)
            this._diagramInfo.setState(props);
    }

    // @ts-ignore
    private _onMouseEnter = (ev: React.MouseEvent<HTMLDivElement>, date?: Date, barData?: BarItemValues) => {
        const props: DiagramInfoState = { cursorX: ev.clientX, cursorY: ev.clientY, data: { date: date }, bar: barData };

        if (this.state.showPopUp) {
            this._updateInfoPosition(props);
        } else {
            this.setState({ showPopUp: true }, () => {
                this._updateInfoPosition(props);
            });
        }
    }

    private _onMouseLeave = () => {
        if (this.state) {
            this.setState({ showPopUp: false });
        }
    }

    private _setBarWrapperRef = (r: HTMLDivElement) => {
        this._barWrapperRef = r;
    }

    private _setDiagramInfoRef = (r: Info) => {
        this._diagramInfo = r;
    }

    private _setPaddingFillerRef = (r: HTMLDivElement) => {
        this._paddingFillerRef = r;
    }

    private _setCapacityOverloadState = (on: boolean, overload?: StringKeyDictionary<Array<number>>) => {
        const oData = overload || this._computation.getResourcesWithOverload();

        const cellsContainer = this._propsData.scheduler.cells.findXy(null, null);
        for (let id in oData) {
            const row = this._propsData.scheduler.rows.find(id);
            //maybe the resource is not shown anymore...
            if (this._icuh.hasValue(row)) {
                if (on) {
                    row.removeClass(SchedulerResourceHeaderClasses.Selected);
                    row.addClass(SchedulerResourceHeaderClasses.Overload);
                } else {
                    row.removeClass(SchedulerResourceHeaderClasses.Overload);
                }

                const cells = row.cells.all();
                oData[id].forEach((c: number) => {
                    if (this._icuh.hasValue(cells[c])) {
                        cellsContainer.push(cells[c]);
                    }
                });
            }
        }

        if (on) {
            cellsContainer.addClass(SchedulerClasses.Overload);
        } else {
            cellsContainer.removeClass(SchedulerClasses.Overload);
        }
    }

    private _setOverload = (on: boolean, force: boolean, clearCurrent: boolean) => {
        //console.time("draw overload");
        if (this._propsData.settings.ShowOverload && (this._icuh.hasValue(this._refreshMode) || force)) {
            const overload = this._computation.getResourcesWithOverload();
            //always clear
            if (clearCurrent) {
                this._setCapacityOverloadState(false, overload.current);
            } else {
                if (this._icuh.hasValue(overload.previous)) {
                    this._setCapacityOverloadState(false, overload.previous);
                }
            }
            //if should mark, call with true
            if (on) {
                this._setCapacityOverloadState(true, overload.current);
            }
        }
        //console.timeEnd("draw overload");
    }

    private _setResourceSelectedState = (row: DayPilot.Row, preferedState?: boolean) => {
        const idx = this._selectedResources.indexOf(row.id);

        if (idx === -1) {
            //the row is currently  not selected
            //null or true
            if (preferedState !== false) {
                //add the id to the selected ids list
                this._selectedResources.push(row.id);
                //if the diagram is shown...
                if (this.props.showDiagram || this._diagramWillShow) {
                    //...visually select the row
                    row.addClass(SchedulerResourceHeaderClasses.Selected);
                }
            } else {
                //do nothing: cannot deselect a "not selected" row
            }
        } else {
            //the row is currently selected
            //null or false
            if (preferedState !== true) {
                //remove the id from the selected ids list
                this._selectedResources.splice(idx, 1);
                //if the diagram is shown...
                //if (this.props.showDiagram || this._diagramWillShow) {
                //...visually deselect the row
                row.removeClass(SchedulerResourceHeaderClasses.Selected);
                row.removeClass(SchedulerResourceHeaderClasses.Overload);
                //}
            }
        }
    }

    private _reselectSelectedResources = (row: DayPilot.Row) => {
        const idx = this._selectedResources.indexOf(row.id);

        if (idx === -1) {
            row.removeClass(SchedulerResourceHeaderClasses.Selected);
        }
        else {
            row.addClass(SchedulerResourceHeaderClasses.Selected);
        }
    }

    private _prepareData = () => {
        //console.time("prepare data");
        if (this._icuh.hasValue(this._refreshMode)) {
            this._propsData = this.props.getData();
            this._checkAndSetWindowResizeHandler();
            if (this._refreshMode === CapacityRefreshMode.Reload) {
                this._selectedResources.length = 0;
                //clear overload
                this._setOverload(false, true, true);
                this.selectAllResources(false);
            }

            if (!this._awaitTrigger) {
                const visibleResources = this._propsData.scheduler.rows.visible().map(r => r.id);
                const targetResources = visibleResources.filter(r => this._selectedResources.indexOf(r) !== -1)
                const resources = this._propsData.resources.filter(r => targetResources.indexOf(r.Id) !== -1);
                const assignments = this._propsData.assignments.filter(a => targetResources.indexOf(a.ResourceId) !== -1 && (a.Hidden !== true || this._considerHiddenAssignments));

                this._computation.computeCapacity({
                    days: this._propsData.scheduler.days,
                    units: this._getNumberOfColumns(),
                    resources: resources,
                    assignments: assignments,
                    startDate: this._propsData.startDate,
                    scale: this._propsData.scale,
                    ignoreUtilTravelTimes: this._propsData.ignoreUtilTravelTimes,
                    rosterDayInfos: this._propsData.rosterDayInfos
                });

                const marks = this._getPositionForPercentageMarks();

                this._afterComputationData.stats.resources = targetResources.filter(r => r.indexOf("r|") === 0).length;
                this._afterComputationData.stats.containers = targetResources.length - this._afterComputationData.stats.resources;
                this._afterComputationData.counts.resources = visibleResources.filter(r => r.indexOf("r|") === 0).length;
                this._afterComputationData.counts.containers = visibleResources.length - this._afterComputationData.counts.resources;
                this._afterComputationData.marks.fifty = marks.fifty;
                this._afterComputationData.marks.hundred = marks.hundred;
            }
        }
    }

    private _getPositionForPercentageMarks = () => {
        //hardcoded values: 130 = the height of the diagram, 20 the height of the date header
        const barHeight = 130 - 20;
        let hundred = barHeight * 0.8;
        let fifty = hundred / 2;

        return { fifty, hundred };
    }

    private _runIfVisible = (func: () => void) => {
        if (this.props.showDiagram) {
            func();
        }
    }

    private _onWindowResize = () => {
        this.setState({});
    }

    private _checkAndSetWindowResizeHandler = () => {
        if (!this._resizeHandlerSet && this._propsData.scheduler.cellWidthSpec === "Auto") {
            $(window).on("resize", this._onWindowResize);
            this._resizeHandlerSet = true;
        }
    }

    private _removeWindowResizeHandler = () => {
        $(window).off("resize", this._onWindowResize);
        this._resizeHandlerSet = false;
    }

    public dropAwaitTrigger = () => {
        this._awaitTrigger = false;
    }

    public selectAllResources = (awaitTrigger: boolean) => {
        this._propsData.scheduler.rows.all().forEach(r => this._setResourceSelectedState(r, true));
        //ignore if false (could be overwritten internally...)
        if (awaitTrigger) {
            this._awaitTrigger = awaitTrigger;
        }
    }

    public reselectSelectedResources = () => {
        if (this._propsData && this._propsData.scheduler) {
            this._propsData.scheduler.rows.all().forEach(r => this._reselectSelectedResources(r));
        }
    }

    public deselectAllResources = (awaitTrigger: boolean) => {
        this._propsData.scheduler.rows.all().forEach(r => this._setResourceSelectedState(r, false));
        //ignore if false (could be overwritten internally...)
        if (awaitTrigger) {
            this._awaitTrigger = awaitTrigger;
        }
    }

    public updatePaddingFillerWidth = (show: boolean) => {
        $(this._paddingFillerRef).width(show ? this._icuh.getScrollBarHeight() + 1 : 0);
    }

    public updateScrollPosition = (x: number) => {
        $(this._barWrapperRef).scrollLeft(x);
    }

    public updateLegendWidth = () => {
        this.setState({});
    }

    public updateCellWidth = () => {
        this.setState({});
    }

    public refresh = (mode: CapacityRefreshMode) => {
        this._refreshMode = mode;
        if (this._refreshMode === CapacityRefreshMode.ApplyFilter) {
            this._awaitTrigger = false;
            this._refreshMode = CapacityRefreshMode.Recompute;
        }
        this.setState({}, () => {
            this._refreshMode = null;
        });
    }

    public handleResourceDoubleClick = (row: DayPilot.Row, awaitTrigger: boolean) => {
        this._setResourceSelectedState(row);
        //ignore if false (could be overwritten internally...)
        if (awaitTrigger) {
            this._awaitTrigger = awaitTrigger;
        }
    }

    handleResourceRowFilter = (args: DayPilot.SchedulerRowFilterArgs) => {
        args.visible = args.filterParam.resourceIds.indexOf(args.row.id) !== -1;
    }

    setConsiderHiddenAssignmentsForComputation = (useHidden: boolean) => {
        if (this._considerHiddenAssignments !== useHidden) {
            this._considerHiddenAssignments = useHidden
            if (this.props.showDiagram) {
                this.refresh(CapacityRefreshMode.Reload);
            }
        }
    }

    componentDidMount() {
        this._runIfVisible(() => {
            this.updateScrollPosition(this._propsData.initialScrollPosition);
            this._setOverload(true, true, false);
        });
        if (this._icuh.hasValue(this.props.afterDiagramLoaded)) {
            this.props.afterDiagramLoaded();
        }
    }

    //Legacy
    UNSAFE_componentWillUpdate(nextProps: CapacityDiagramProps) {
        if (nextProps.showDiagram === true && nextProps.showDiagram !== this.props.showDiagram) {
            this._refreshMode = CapacityRefreshMode.Reload;
            this._diagramWillShow = true;
        }
        this._prepareData();
        this.reselectSelectedResources();
    }

    componentDidUpdate(prevProps: CapacityDiagramProps) {
        //check if the diagram is "closed"
        if (this.props.showDiagram === false && this.props.showDiagram !== prevProps.showDiagram) {
            //clear overload
            this._setOverload(false, true, true);
            //unselect resources
            this.deselectAllResources(false);
            //remove resize event handling
            this._removeWindowResizeHandler();
        } else {
            //console.time("paint overload")
            this._runIfVisible(() => {
                //diagram is still visible => update overtime cells
                this._setOverload(true, false, false);
            });
            //console.timeEnd("paint overload")
        }

        this._refreshMode = null;
        this._diagramWillShow = false;
        this.reselectSelectedResources();
    }

    componentWillUnmount() {
        this._runIfVisible(() => {
            //clear overload
            this._setOverload(false, true, true);
            //unselect resources
            this.deselectAllResources(false);
        });
    }

    render() {
        if (this.props.showDiagram) {
            const lblSelectedResources = `${this._afterComputationData.stats.resources}/${this._afterComputationData.counts.resources} ${this._propsData.translations["Kapazitaet.AusgewaehlteRes"]}`;
            const lblSelectedGroups = `${this._afterComputationData.stats.containers}/${this._afterComputationData.counts.containers} ${this._propsData.translations["Kapazitaet.AusgewaehlteGr"]}`;

            return (
                this._propsData.scale === "Hour" ? null :
                    <div className="capacity-diagram">
                        <div className="capacity-diagram__legend" style={{ width: (this._propsData.scheduler.rowHeaderColumns.map(c => c.width).reduce((p, c) => p + c, 0)) + "px" }}>
                            <div className="capacity-diagram__legend__colors">
                                <label><span className={CapacityColorClasses.Color + " " + CapacityColorClasses.Overload} />{this._propsData.translations["Kapazitaet.Ueber"]}</label>
                                <label><span className={CapacityColorClasses.Color + " " + CapacityColorClasses.Absent} />{this._propsData.translations["Kapazitaet.Absent"]}</label>
                                <label><span className={CapacityColorClasses.Color + " " + CapacityColorClasses.Internal} />{this._propsData.translations["Kapazitaet.Intern"]}</label>
                                <label><span className={CapacityColorClasses.Color + " " + CapacityColorClasses.External} />{this._propsData.translations["Kapazitaet.Extern"]}</label>
                                <label><span className={CapacityColorClasses.Color + " " + CapacityColorClasses.Assignment} />{this._propsData.translations["Kapazitaet.Einsaetze"]}</label>
                            </div>
                            <div className="capacity-diagram__legend__summary">
                                <label title={lblSelectedResources}>{lblSelectedResources}</label>
                                <label title={lblSelectedGroups}>{lblSelectedGroups}</label>
                            </div>
                        </div>
                        <div className="capacity-diagram__bars">
                            <div className="capacity-diagram__bars__container" ref={this._setBarWrapperRef} onMouseEnter={ev => this._onMouseEnter(ev, null, null)} onMouseLeave={this._onMouseLeave}>
                                {this._renderColumns()}
                            </div>
                            {
                                this._propsData.renderScrollBarPadding ?
                                    <div className="capacity-diagram__bars__spacer" style={{ width: this._icuh.getScrollBarHeight() + 1 }} ref={this._setPaddingFillerRef} />
                                    : null
                            }
                            {
                                this._afterComputationData.marks.fifty > 0 ?
                                    <div className="capacity-diagram__bars__indicator capacity-diagram__bars__50" style={{ bottom: this._afterComputationData.marks.fifty + "px" }} />
                                    : null
                            }
                            {
                                this._afterComputationData.marks.hundred > 0 ?
                                    <div className="capacity-diagram__bars__indicator capacity-diagram__bars__100" style={{ bottom: this._afterComputationData.marks.hundred + "px" }} />
                                    : null
                            }
                        </div>
                        {
                            this.state.showPopUp === false ?
                                null :
                                <Info ref={this._setDiagramInfoRef} scale={this._propsData.scale} translations={this._propsData.translations} />
                        }
                    </div>
            );
        } else {
            return null;
        }
    }

    private _getCellsData(isProzent: boolean, ci: CapaReportInfo): WorkbookSheetRowCell[] {
        let captionScale = this._icuh.getTranslation("Kapazitaet.Weekday");
        if (ci.scale == "Week")
            captionScale = this._icuh.getTranslation("WebSMS.ResourcePlanningScheduler.Kalenderwoche");
        if (ci.scale == "Month")
            captionScale = this._icuh.getTranslation("Standard.Monat");

        const color = isProzent ? "#0000ff" : "#ff0000";
        const detail = isProzent ? " [%]" : " [" + this._icuh.getTranslation("Kapazitaet.Std") + "]";

        // const format = "0,00";

        return [
            { value: captionScale, color: color, bold: true },
            { value: this._icuh.getTranslation("Standard.Datum"), color: color, bold: true },
            { value: this._icuh.getTranslation("Kapazitaet.Einsaetze") + detail, color: color, bold: true },
            { value: this._icuh.getTranslation("Kapazitaet.Extern") + detail, color: color, bold: true },
            { value: this._icuh.getTranslation("Kapazitaet.Absent") + detail, color: color, bold: true },
            { value: this._icuh.getTranslation("Kapazitaet.Ueber") + detail, color: color, bold: true },
            { value: this._icuh.getTranslation("Kapazitaet.Intern") + detail, color: color, bold: true },
            { value: this._icuh.getTranslation("Kapazitaet.Summe") + detail, color: color, bold: true },
            { value: this._icuh.getTranslation("Kapazitaet.Frei") + detail, color: color, bold: true }
        ];
    }
    private _getRowData(isProzent: boolean, ci: CapaReportInfo, i: number): kendo.ooxml.WorkbookSheetRow {

        let column1: string;
        let column2: string | Date;

        if (ci.scale == "Day") {
            const date = this._icuh.dates.addDays(ci.von, i);
            column1 = this._icuh.dates.getDayOfWeekLabel(date.getDay() + 1);
            column2 = this._icuh.dates.removeTime(date);
        }

        if (ci.scale == "Week") {
            const date1 = new DayPilot.Date(ci.von, true).addDays(i * 7);
            const date2 = new DayPilot.Date(ci.von, true).addDays(i * 7 + 6);
            column1 = date1.weekNumberISO().toString();
            column2 = date1.toDateLocal().toLocaleDateString() + "-" + date2.toDateLocal().toLocaleDateString();
        }

        if (ci.scale == "Month") {
            const date3 = new DayPilot.Date(ci.von, true).addMonths(i);
            column1 = SchedulerLocaleLabels[Config.user.languageId === 0 ? "de-de" : "en-gb"].monthsShort[date3.getMonth()];
            column2 = this._icuh.dates.removeTime(date3.toDateLocal());
        }

        const val = ci.aggregated[i];

        const sum = isProzent ?
            val.assignment + val.external + val.absent + val.overload + val.intern :
            val.assignment_abs + val.external_abs + val.absent_abs + val.overload_abs + val.intern_abs;

        const res = {
            cells: [
                { value: column1 },
                { value: column2 },
                { value: isProzent ? val.assignment : val.assignment_abs },
                { value: isProzent ? val.external : val.external_abs },
                { value: isProzent ? val.absent : val.absent_abs },
                { value: isProzent ? val.overload : val.overload_abs },
                { value: isProzent ? val.intern : val.intern_abs },
                { value: sum },
                { value: isProzent ? val.spare : val.spare_abs }]
        };

        return res;
    }
    public exportDiagramToExcel = () => {
        const ci: CapaReportInfo = {
            von: this._icuh.dates.removeTime(this._propsData.startDate),
            bis: this._icuh.dates.removeTime(this._propsData.endDate),
            selResources: this._afterComputationData.stats.resources,
            allResources: this._afterComputationData.counts.resources,
            selGroups: this._afterComputationData.stats.containers,
            allGroups: this._afterComputationData.counts.containers,
            resources: this._computation.getResources(),
            normalized: this._computation.getNormalized(),
            aggregated: this._computation.getAggregatedCapacities(),
            scale: this._propsData.scale
        };

        //Hours-ansicht nicht unterstützt 
        if (ci.scale == "Hour")
            return;

        //Datei-name generieren 
        let reportScale = "";
        const now = this._icuh.dates.removeTime(new Date());


        if (ci.scale == "Day") {
            reportScale = this._icuh.getTranslation("WebSMS.Common.DateTime.Tage");
        }

        if (ci.scale == "Week") {
            reportScale = this._icuh.getTranslation("WebSMS.Common.DateTime.Wochen");
        }

        if (ci.scale == "Month") {
            reportScale = this._icuh.getTranslation("WebSMS.Common.DateTime.Monate");
        }

        if (!this._icuh.hasValue(reportScale))
            reportScale = ci.scale;

        let reportName = this._icuh.getTranslation("WebSMS.ResourcePlanning.Auslastung");
        if (!this._icuh.hasValue(reportName))
            reportName = "Capacity_utilization";
        reportName = reportName + "_" + this._icuh.dates.formatDateTime(now, "dd_mm_yyyy_hh_mm") + "_" + reportScale + ".xlsx";

        //Konstanten
        const emptyRow: kendo.ooxml.WorkbookSheetRow = {};
        const emptyCell: kendo.ooxml.WorkbookSheetRowCell = {};

        //Spalten defaults
        const width = 120;
        const columnsWidth: WorkbookSheetColumn[] = [{ width: width }, { width: width }, { width: width }, { width: width }, { width: width },
        { width: width }, { width: width }, { width: width }, { width: width }];

        //Report details
        const rowReportName: kendo.ooxml.WorkbookSheetRow =
            { cells: [{ value: this._icuh.getTranslation("WebSMS.ResourcePlanning.Auslastung"), bold: true }, { value: reportName }] };
        const rowReportScale: kendo.ooxml.WorkbookSheetRow =
            { cells: [{ value: this._icuh.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.Zoom"), bold: true }, { value: reportScale }] };
        const rowReportDate: kendo.ooxml.WorkbookSheetRow =
            { cells: [{ value: this._icuh.getTranslation("Standard.Datum"), bold: true }, { value: now }] };
        const rowReportVon: kendo.ooxml.WorkbookSheetRow = { cells: [{ value: this._icuh.getTranslation("Standard.Von"), bold: true }, { value: ci.von }] };
        const rowReportBis: kendo.ooxml.WorkbookSheetRow = { cells: [{ value: this._icuh.getTranslation("Standard.Bis"), bold: true }, { value: ci.bis }] };
        const rowReportResourcesInfo: kendo.ooxml.WorkbookSheetRow =
            { cells: [{ value: this._icuh.getTranslation("Ressource.Ressourcen"), bold: true }, { value: ci.allResources + "\\" + ci.selResources }] };
        const rowReportGroupInfo: kendo.ooxml.WorkbookSheetRow =
            { cells: [{ value: this._icuh.getTranslation("WebCRM.Administration.Gruppen"), bold: true }, { value: ci.allGroups + "\\" + ci.selGroups }] };

        //Report headers
        const rowReportHeaderProzent: kendo.ooxml.WorkbookSheetRow = { cells: this._getCellsData(true, ci) };
        const rowReportHeaderHours: kendo.ooxml.WorkbookSheetRow = { cells: this._getCellsData(false, ci) };

        const workbookDef: WorkbookSheetRow[] = [
            rowReportName,
            rowReportScale,
            rowReportDate,
            rowReportVon,
            rowReportBis,
            rowReportResourcesInfo,
            rowReportGroupInfo,
            emptyRow];

        //sheet 1
        const workbookProzent: WorkbookSheetRow[] = Object.assign([], workbookDef);
        workbookProzent.push(rowReportHeaderProzent);

        for (let i = 0; i < ci.normalized.length; i++)
            workbookProzent.push(this._getRowData(true, ci, i));

        //sheet 2
        const workbookHours: WorkbookSheetRow[] = Object.assign([], workbookDef);
        workbookHours.push(rowReportHeaderHours);

        for (let i = 0; i < ci.normalized.length; i++)
            workbookHours.push(this._getRowData(false, ci, i));

        //sheet 3
        const workbookResDetail: WorkbookSheetRow[] = Object.assign([], workbookDef);
        workbookResDetail.push({
            cells: [{
                value: this._icuh.getTranslation("Kapazitaet.AusgewaehlteRes"), bold: true
            },
                emptyCell,
            { value: this._icuh.getTranslation("Kapazitaet.AusgewaehlteGr"), bold: true }]
        });

        const rList: string[] = [];
        const gList: string[] = [];

        Object.keys(ci.resources).forEach((key) => {
            const ri = ci.resources[key];
            if (key.startsWith("r|"))
                rList.push(ri.model.Id.substring(2) + " " + ri.model.Text);
            if (key.startsWith("g|"))
                gList.push(ri.model.Text);
        });

        rList.sort();
        gList.sort();

        const max = Math.max(rList.length, gList.length);

        for (let i = 0; i < max; i++) {
            const r = i <= rList.length - 1 ? rList[i] : null;
            const g = i <= gList.length - 1 ? gList[i] : null;

            const row: kendo.ooxml.WorkbookSheetRow = { cells: [{ value: r }, emptyCell, { value: g },] };
            workbookResDetail.push(row);
        }

        //workbook
        let workbook = new kendo.ooxml.Workbook({
            sheets: [
                {
                    columns: columnsWidth,
                    title: "percent",
                    rows: workbookProzent
                },
                {
                    columns: columnsWidth,
                    title: "hours",
                    rows: workbookHours
                },
                {
                    columns: columnsWidth,
                    title: "details",
                    rows: workbookResDetail
                }
            ]
        });

        const dataURL = workbook.toDataURL();
        kendo.saveAs({
            dataURI: dataURL,
            fileName: reportName
        });
    }
}

export class Info extends React.Component<DiagramInfoProps, DiagramInfoState> {
    private _icuh = GlobalHelper;
    protected _infoElementRef: HTMLDivElement = null;
    private _values = {
        width: 200,
        height: 170,
        offset: 20,
        flipThreshold: 30
    };

    constructor(props: DiagramInfoProps) {
        super(props);
        this.state = {
            cursorX: 0,
            cursorY: 0,
            data: {
                date: null
            },
            bar: null
        };
    }

    private _getDateInfo = () => {
        if (this._icuh.hasValue(this.state.data.date)) {
            switch (this.props.scale) {
                case "Day":
                    return this._icuh.dates.toString(this.state.data.date);
                case "Week":
                    const dpd = new DayPilot.Date(this.state.data.date, true);
                    return dpd.weekNumberISO().toString();
                case "Month":
                    const month = SchedulerLocaleLabels[Config.user.languageId === 0 ? "de-de" : "en-gb"].months[this.state.data.date.getMonth()];
                    return `${month} ${this.state.data.date.getFullYear()}`;
                default:
                    return null;
            }
        } else {
            return null;
        }
    }

    private _getPosition = () => {
        const pos = {
            top: this.state.cursorY - this._values.offset - this._values.height,
            left: this.state.cursorX + this._values.offset
        };

        if (pos.left + this._values.width + this._values.flipThreshold > window.innerWidth) {
            pos.left -= this._values.width + 2 * this._values.offset;
        }

        return pos;
    }

    private _getDateLabel = () => {
        let key = "Kapazitaet.Tag"
        if (this.props.scale === "Week") {
            key = "Kapazitaet.Woche"
        } else if (this.props.scale === "Month") {
            key = "Kapazitaet.Monat"
        }

        return this.props.translations[key];
    }

    public updatePosition = (x: number, y: number) => {
        $(this._infoElementRef).css({ left: (x + 20) + "px", top: (y - 20 - 150) + "px" });
    }

    render() {
        const pos = this._getPosition();
        const bar = this._icuh.hasValue(this.state.bar) ? this.state.bar : null;

        return (

            bar === null ? null :
                <div className="capacity-diagram__info" style={{
                    minWidth: this._values.width + "px",
                    height: this._values.height + "px",
                    top: pos.top + "px",
                    left: pos.left + "px",
                    zIndex: 99
                }
                } ref={r => this._infoElementRef = r} >
                    <h4>{this.props.translations["Kapazitaet.Zusammenfassung"]}</h4>
                    <table>
                        <thead>
                            <tr>
                                <th>{this._getDateLabel()}</th>
                                <th colSpan={2}>{this._getDateInfo()}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{this.props.translations["Kapazitaet.Frei"]}</td>
                                <td>{bar.spare}%</td>
                                <td>{bar.spare_abs}</td>
                            </tr>
                            <tr>
                                <td>{this.props.translations["Kapazitaet.Ueber"]}</td>
                                <td>{bar.overload}%</td>
                                <td>{bar.overload_abs}</td>
                            </tr>
                            <tr>
                                <td>{this.props.translations["Kapazitaet.Extern"]}</td>
                                <td>{bar.external}%</td>
                                <td>{bar.external_abs}</td>
                            </tr>
                            <tr>
                                <td>{this.props.translations["Kapazitaet.Absent"]}</td>
                                <td>{bar.absent}%</td>
                                <td>{bar.absent_abs}</td>
                            </tr>
                            <tr>
                                <td>{this.props.translations["Kapazitaet.Intern"]}</td>
                                <td>{bar.intern}%</td>
                                <td>{bar.intern_abs}</td>
                            </tr>
                            <tr>
                                <td>{this.props.translations["Kapazitaet.Einsaetze"]}</td>
                                <td>{bar.assignment}%</td>
                                <td>{bar.assignment_abs}</td>
                            </tr>
                        </tbody>
                    </table>
                </div >
        );
    }
}

export class Computation {
    private _icuh = GlobalHelper;
    private _days: number = 0;
    private _units: number = 0;
    private _startDate: Date;
    private _normalizedValues: Array<BarItemValues> = [];
    private _resources: StringKeyDictionary<ResourceInfo> = {};
    private _assignments: Array<AssignmentInfo> = [];
    private _ignoreUtilTravelTimes: boolean = false;
    private _stats = {
        counts: {
            resources: {
                [ResourceType.Container]: 0,
                [ResourceType.External]: 0,
                [ResourceType.Internal]: 0,
            }
        },
        normalDailyAvailablity: {
            [ResourceType.Container]: 0,
            [ResourceType.External]: 0,
            [ResourceType.Internal]: 0,
        }
    };
    private _dailyGroupedData: GroupedData = {
        availability: {
            [ResourceType.Container]: [] as Array<number>,
            [ResourceType.External]: [] as Array<number>,
            [ResourceType.Internal]: [] as Array<number>
        },
        demand: {
            [ResourceType.Container]: [] as Array<number>,
            [ResourceType.External]: [] as Array<number>,
            [ResourceType.Internal]: [] as Array<number>
        },
        overload: {
            [ResourceType.Container]: [] as Array<number>,
            [ResourceType.External]: [] as Array<number>,
            [ResourceType.Internal]: [] as Array<number>
        },
        absent: {
            [ResourceType.Container]: [] as Array<number>,
            [ResourceType.External]: [] as Array<number>,
            [ResourceType.Internal]: [] as Array<number>
        },
        intern: {
            [ResourceType.Container]: [] as Array<number>,
            [ResourceType.External]: [] as Array<number>,
            [ResourceType.Internal]: [] as Array<number>
        },
        containerOverload: [] as Array<number>
    };
    private _finalGroupedData: GroupedData = {
        availability: {
            [ResourceType.Container]: [] as Array<number>,
            [ResourceType.External]: [] as Array<number>,
            [ResourceType.Internal]: [] as Array<number>
        },
        demand: {
            [ResourceType.Container]: [] as Array<number>,
            [ResourceType.External]: [] as Array<number>,
            [ResourceType.Internal]: [] as Array<number>
        },
        overload: {
            [ResourceType.Container]: [] as Array<number>,
            [ResourceType.External]: [] as Array<number>,
            [ResourceType.Internal]: [] as Array<number>
        },
        absent: {
            [ResourceType.Container]: [] as Array<number>,
            [ResourceType.External]: [] as Array<number>,
            [ResourceType.Internal]: [] as Array<number>
        },
        intern: {
            [ResourceType.Container]: [] as Array<number>,
            [ResourceType.External]: [] as Array<number>,
            [ResourceType.Internal]: [] as Array<number>
        },
        containerOverload: [] as Array<number>
    };
    private _aggregatedCapacities: Array<BarItemValues> = [];
    //helper arrays ([0...0] and [1..1]) with length = days
    private _constants = {
        zeroes: [] as Array<0>,
        ones: [] as Array<1>
    }
    private _scale: "Hour" | "Day" | "Week" | "Month" = null;
    private _previousOverloadData: StringKeyDictionary<Array<number>> = null;
    private _currentOverloadData: StringKeyDictionary<Array<number>> = null;

    private _getZeroes = () => {
        return this._constants.zeroes.slice();
    }

    public getResources(): StringKeyDictionary<ResourceInfo> {
        return this._resources;
    }

    public getNormalized(): Array<BarItemValues> {
        return this._normalizedValues;
    }

    public getAggregatedCapacities(): Array<BarItemValues> {
        return this._aggregatedCapacities;
    }

    //creates the _resources dictionary, add additional info for the resource and prepares the capacity arrays
    private _prepareResources = (rosterDayInfos: Array<RosterDayInfoViewModel>, resources: Array<ResourcePlanningSchedulerResourceViewModel>) => {
        //reset
        Helper.clearDictionary(this._resources);
        this._stats.counts.resources[ResourceType.Container] = 0;
        this._stats.counts.resources[ResourceType.External] = 0;
        this._stats.counts.resources[ResourceType.Internal] = 0;
        this._stats.normalDailyAvailablity[ResourceType.Container] = 0;
        this._stats.normalDailyAvailablity[ResourceType.External] = 0;
        this._stats.normalDailyAvailablity[ResourceType.Internal] = 0;
        this._dailyGroupedData.availability[ResourceType.Container] = this._getZeroes();
        this._dailyGroupedData.availability[ResourceType.External] = this._getZeroes();
        this._dailyGroupedData.availability[ResourceType.Internal] = this._getZeroes();

        //init
        resources.forEach(r => {
            const ri: ResourceInfo = {
                id: r.Id,
                calendarId: r.KalenderId,
                groupId: r.TmpGr,
                type: Helper.getResourceType(r.Id, r.TmpGr),
                assignments: [],
                computed: {
                    absent: this._getZeroes(),
                    demand: this._getZeroes(),
                    actualWork: this._getZeroes(),
                    over: this._getZeroes(),
                    intern: this._getZeroes()
                },
                hasOverload: false,
                model: r,
            };

            //count the number of resources of a specific type
            this._stats.counts.resources[ri.type]++;

            //aggregate the normal (standard working day) working minutes for a specific type
            this._stats.normalDailyAvailablity[ri.type] += Math.round(r.HoursPerDay * 60);

            //aggregate the daily availablity for a specific type
            for (let i = 0; i < this._days; i++) {
                if (ri.type != ResourceType.Container) {
                    //var rdi = r.RosterDayInfo.find(x => x.o == i);
                    var rdi = GetRosterInfoFromArray(rosterDayInfos, r.RosterDayInfo, i);
                    if (rdi != null)
                        this._dailyGroupedData.availability[ri.type][i] += rdi.c * 60;
                }
            }

            this._resources[ri.id] = ri;
        });
    }

    //creates helper array (filled with 0 or 1)
    private _initConstants = () => {
        //init (overwrite, no need for reset)
        this._constants.ones = Helper.getOnesArray(this._days);
        this._constants.zeroes = Helper.getZeroesArray(this._days);
    }

    //iterates the assignments and calculates tha capacities generated nby each
    private _prepareAssignments = (rosterDayInfos: Array<RosterDayInfoViewModel>, assignments: Array<ResourcePlanningSchedulerEventViewModel>) => {
        //reset
        this._assignments.length = 0;

        //init
        assignments.forEach((event) => {
            const ai: AssignmentInfo = {
                source: event,
                days: 0,
                startDateIndex: 0,
                type: IsEventType(event)
            };

            const startDate = this._icuh.dates.toDate(event.Start);
            const endDate = this._icuh.dates.toDate(event.End);

            const assignmentStartIndex = this._icuh.dates.dateDiffInDays(this._startDate, startDate);
            const assignmentEndIndex = this._icuh.dates.dateDiffInDays(this._startDate, endDate);

            ai.startDateIndex = Math.max(0, assignmentStartIndex);
            ai.days = Math.min(this._days - 1, assignmentEndIndex) - ai.startDateIndex + 1;

            const resource = this._resources[ai.source.ResourceId];

            let idx = 0;
            for (let i = ai.startDateIndex; i < ai.startDateIndex + ai.days; i++) {
                var rdi = GetRosterInfoFromArray(rosterDayInfos, resource.model.RosterDayInfo, i);
                if (rdi != null) {
                    let currentDayAssignmentMinutes: number = 0;
                    if (event.AssignmentUtilizationInfo != null) {
                        currentDayAssignmentMinutes = this._ignoreUtilTravelTimes ?
                            event.AssignmentUtilizationInfo.work[idx] :
                            (event.AssignmentUtilizationInfo.arrival[idx] + event.AssignmentUtilizationInfo.work[idx] + event.AssignmentUtilizationInfo.departure[idx]);
                    }
                    const currentResDayCapacityMinutes = rdi.c * 60;

                    if (ai.type === AssignmentType.Absent || ai.type === AssignmentType.Intern) {
                        const a1 = resource.computed.absent[i];
                        resource.computed.absent[i] += currentDayAssignmentMinutes;
                        resource.computed.absent[i] = Math.min(resource.computed.absent[i], currentResDayCapacityMinutes);
                        const a2 = resource.computed.absent[i];

                        if (ai.type === AssignmentType.Intern) {
                            resource.computed.intern[i] += a2 - a1;
                        }
                    }
                    else {
                        resource.computed.demand[i] += currentDayAssignmentMinutes;
                    }

                    if (resource.type != ResourceType.Container) {
                        resource.computed.over[i] = Math.max(0, resource.computed.demand[i] -
                            (currentResDayCapacityMinutes - resource.computed.absent[i]));
                        resource.computed.actualWork[i] = Math.max(0, resource.computed.demand[i] - resource.computed.over[i]);
                    }

                    if (resource.type == ResourceType.Container)
                        resource.computed.actualWork[i] = resource.computed.demand[i];

                    if (resource.type !== ResourceType.Container && resource.computed.over[i] > 0) {
                        resource.hasOverload = true;
                    }
                }
                idx++;
            }

            this._assignments.push(ai);
            resource.assignments.push(ai);
        });
    }

    //groups individual capacities by resource type
    private _computeForGroups = () => {
        //reset
        this._dailyGroupedData.demand[ResourceType.Internal] = this._getZeroes();
        this._dailyGroupedData.demand[ResourceType.External] = this._getZeroes();
        this._dailyGroupedData.demand[ResourceType.Container] = this._getZeroes();
        this._dailyGroupedData.overload[ResourceType.Internal] = this._getZeroes();
        this._dailyGroupedData.overload[ResourceType.External] = this._getZeroes();
        this._dailyGroupedData.overload[ResourceType.Container] = this._getZeroes();
        this._dailyGroupedData.absent[ResourceType.Internal] = this._getZeroes();
        this._dailyGroupedData.absent[ResourceType.External] = this._getZeroes();
        this._dailyGroupedData.absent[ResourceType.Container] = this._getZeroes();
        this._dailyGroupedData.intern[ResourceType.Internal] = this._getZeroes();
        this._dailyGroupedData.intern[ResourceType.External] = this._getZeroes();
        this._dailyGroupedData.intern[ResourceType.Container] = this._getZeroes();
        this._dailyGroupedData.containerOverload = this._getZeroes();

        //count
        for (let id in this._resources) {
            const r = this._resources[id];

            for (let i = 0; i < this._days; i++) {
                this._dailyGroupedData.demand[r.type][i] += r.computed.actualWork[i];
                this._dailyGroupedData.overload[r.type][i] += r.computed.over[i];
                this._dailyGroupedData.absent[r.type][i] += r.computed.absent[i];
                this._dailyGroupedData.intern[r.type][i] += r.computed.intern[i];
            }
        }

        for (let i = 0; i < this._days; i++) {
            this._dailyGroupedData.containerOverload[i] = this._dailyGroupedData.overload[ResourceType.Internal][i] + this._dailyGroupedData.overload[ResourceType.External][i];
        }
    }

    private _getDailyGroupedDataAggregatedByWeek = () => {
        const zeroes = Helper.getZeroesArray(this._units);

        const groupedData: GroupedData = {
            availability: {
                [ResourceType.Container]: zeroes.slice(),
                [ResourceType.External]: zeroes.slice(),
                [ResourceType.Internal]: zeroes.slice()
            },
            demand: {
                [ResourceType.Container]: zeroes.slice(),
                [ResourceType.External]: zeroes.slice(),
                [ResourceType.Internal]: zeroes.slice()
            },
            overload: {
                [ResourceType.Container]: zeroes.slice(),
                [ResourceType.External]: zeroes.slice(),
                [ResourceType.Internal]: zeroes.slice()
            },
            absent: {
                [ResourceType.Container]: zeroes.slice(),
                [ResourceType.External]: zeroes.slice(),
                [ResourceType.Internal]: zeroes.slice()
            },
            intern: {
                [ResourceType.Container]: zeroes.slice(),
                [ResourceType.External]: zeroes.slice(),
                [ResourceType.Internal]: zeroes.slice()
            },
            containerOverload: zeroes.slice()
        };

        for (let i = 0; i < this._units; i++) {
            for (let d = 0; d < 7; d++) {
                const idx = i * 7 + d;

                groupedData.availability[ResourceType.Internal][i] += this._dailyGroupedData.availability[ResourceType.Internal][idx];
                groupedData.availability[ResourceType.External][i] += this._dailyGroupedData.availability[ResourceType.External][idx];
                groupedData.availability[ResourceType.Container][i] += this._dailyGroupedData.availability[ResourceType.Container][idx];

                groupedData.demand[ResourceType.Internal][i] += this._dailyGroupedData.demand[ResourceType.Internal][idx];
                groupedData.demand[ResourceType.External][i] += this._dailyGroupedData.demand[ResourceType.External][idx];
                groupedData.demand[ResourceType.Container][i] += this._dailyGroupedData.demand[ResourceType.Container][idx];

                groupedData.overload[ResourceType.Internal][i] += this._dailyGroupedData.overload[ResourceType.Internal][idx];
                groupedData.overload[ResourceType.External][i] += this._dailyGroupedData.overload[ResourceType.External][idx];
                groupedData.overload[ResourceType.Container][i] += this._dailyGroupedData.overload[ResourceType.Container][idx];

                groupedData.absent[ResourceType.Internal][i] += this._dailyGroupedData.absent[ResourceType.Internal][idx];
                groupedData.absent[ResourceType.External][i] += this._dailyGroupedData.absent[ResourceType.External][idx];
                groupedData.absent[ResourceType.Container][i] += this._dailyGroupedData.absent[ResourceType.Container][idx];

                groupedData.intern[ResourceType.Internal][i] += this._dailyGroupedData.intern[ResourceType.Internal][idx];
                groupedData.intern[ResourceType.External][i] += this._dailyGroupedData.intern[ResourceType.External][idx];
                groupedData.intern[ResourceType.Container][i] += this._dailyGroupedData.intern[ResourceType.Container][idx];

                groupedData.containerOverload[i] += this._dailyGroupedData.containerOverload[idx];
            }
        }

        return groupedData;
    }

    private _getDailyGroupedDataAggregatedByMonth = () => {
        const zeroes = Helper.getZeroesArray(this._units);

        const groupedData: GroupedData = {
            availability: {
                [ResourceType.Container]: zeroes.slice(),
                [ResourceType.External]: zeroes.slice(),
                [ResourceType.Internal]: zeroes.slice()
            },
            demand: {
                [ResourceType.Container]: zeroes.slice(),
                [ResourceType.External]: zeroes.slice(),
                [ResourceType.Internal]: zeroes.slice()
            },
            overload: {
                [ResourceType.Container]: zeroes.slice(),
                [ResourceType.External]: zeroes.slice(),
                [ResourceType.Internal]: zeroes.slice()
            },
            absent: {
                [ResourceType.Container]: zeroes.slice(),
                [ResourceType.External]: zeroes.slice(),
                [ResourceType.Internal]: zeroes.slice()
            },
            intern: {
                [ResourceType.Container]: zeroes.slice(),
                [ResourceType.External]: zeroes.slice(),
                [ResourceType.Internal]: zeroes.slice()
            },
            containerOverload: zeroes.slice()
        };

        let monthIdx = 0;
        let currentMonth = this._startDate.getMonth();
        for (let d = 0; d < this._days; d++) {
            const date = this._icuh.dates.addDays(this._startDate, d);
            const mnt = date.getMonth();
            if (currentMonth !== mnt) {
                monthIdx++;
                currentMonth = mnt;
            }

            groupedData.availability[ResourceType.Internal][monthIdx] += this._dailyGroupedData.availability[ResourceType.Internal][d];
            groupedData.availability[ResourceType.External][monthIdx] += this._dailyGroupedData.availability[ResourceType.External][d];
            groupedData.availability[ResourceType.Container][monthIdx] += this._dailyGroupedData.availability[ResourceType.Container][d];

            groupedData.demand[ResourceType.Internal][monthIdx] += this._dailyGroupedData.demand[ResourceType.Internal][d];
            groupedData.demand[ResourceType.External][monthIdx] += this._dailyGroupedData.demand[ResourceType.External][d];
            groupedData.demand[ResourceType.Container][monthIdx] += this._dailyGroupedData.demand[ResourceType.Container][d];

            groupedData.overload[ResourceType.Internal][monthIdx] += this._dailyGroupedData.overload[ResourceType.Internal][d];
            groupedData.overload[ResourceType.External][monthIdx] += this._dailyGroupedData.overload[ResourceType.External][d];
            groupedData.overload[ResourceType.Container][monthIdx] += this._dailyGroupedData.overload[ResourceType.Container][d];

            groupedData.absent[ResourceType.Internal][monthIdx] += this._dailyGroupedData.absent[ResourceType.Internal][d];
            groupedData.absent[ResourceType.External][monthIdx] += this._dailyGroupedData.absent[ResourceType.External][d];
            groupedData.absent[ResourceType.Container][monthIdx] += this._dailyGroupedData.absent[ResourceType.Container][d];

            groupedData.intern[ResourceType.Internal][monthIdx] += this._dailyGroupedData.intern[ResourceType.Internal][d];
            groupedData.intern[ResourceType.External][monthIdx] += this._dailyGroupedData.intern[ResourceType.External][d];
            groupedData.intern[ResourceType.Container][monthIdx] += this._dailyGroupedData.intern[ResourceType.Container][d];

            groupedData.containerOverload[monthIdx] += this._dailyGroupedData.containerOverload[d];
        }

        return groupedData;
    }

    //computes the daily (time & type) percentages for each resource
    private _computeRawValues = (groupedData: GroupedData/*, clearWeekend: boolean*/) => {
        const capacities: Array<BarItemValues> = [];

        for (let i = 0; i < this._units; i++) {
            const capaContainer: BarItemValues = {
                absent: 0,
                assignment: 0,
                external: 0,
                spare: 0,
                overload: 0,
                intern: 0,

                absent_abs: 0,
                assignment_abs: 0,
                external_abs: 0,
                spare_abs: 0,
                overload_abs: 0,
                intern_abs: 0
            };

            let internalDailyCapacity = 0;
            let externalDailyCapacity = 0;

            let internalDailyDemand = 0;
            let externalDailyDemand = 0;

            let containerOverload = groupedData.containerOverload[i];
            let internalAbsents = groupedData.absent[ResourceType.Internal][i];
            let internalIntern = groupedData.intern[ResourceType.Internal][i];

            internalDailyCapacity = groupedData.availability[ResourceType.Internal][i];
            internalDailyDemand = groupedData.demand[ResourceType.Internal][i] + groupedData.demand[ResourceType.Container][i];

            externalDailyCapacity = groupedData.availability[ResourceType.External][i];
            externalDailyDemand = groupedData.demand[ResourceType.External][i];

            const internalFactor = internalDailyCapacity === 0 ? 0 : 100 / internalDailyCapacity;
            const externalFactor = internalFactor !== 0 ? internalFactor : 100 / externalDailyDemand;

            let assignment = internalDailyDemand * internalFactor;
            assignment = Math.round(assignment * 100) / 100;//2 decimals

            let absent = internalAbsents * internalFactor;
            absent = Math.round(absent * 100) / 100;//2 decimals

            let intern = internalIntern * internalFactor;
            intern = Math.round(intern * 100) / 100;//2 decimals

            let free = 0;//not to be confused with holidays and personal time; is the the time available after all the assignments have been assigned
            if (internalDailyCapacity > 0 && (assignment + absent < 100))
                free = 100 - assignment - absent;
            free = Math.round(free * 100) / 100;//2 decimals

            //todo: check!!!
            let overload = 0;
            if (internalDailyCapacity === 0) {//should be weekend => add additional constraints ((()))      
                overload = containerOverload * 100 / this._stats.normalDailyAvailablity[ResourceType.Internal];
            } else {
                overload = containerOverload * internalFactor;
            }
            overload = Math.round(overload * 100) / 100;//2 decimals

            let external = 0;
            if (externalDailyCapacity === 0) {
            } else {
                external = externalDailyDemand * externalFactor;
            }
            if (isFinite(external)) {
                external = Math.round(external * 100) / 100;//2 decimals
            } else {
                external = 0;
            }



            capaContainer.assignment = isFinite(assignment) ? assignment : 0;
            capaContainer.spare = isFinite(free) ? free : 0;
            capaContainer.absent = isFinite(absent - intern) ? Math.round((absent - intern) * 100) / 100 : 0;
            capaContainer.external = isFinite(external) ? external : 0;
            capaContainer.overload = isFinite(overload) ? overload : 0;
            capaContainer.intern = isFinite(intern) ? intern : 0;

            capaContainer.assignment_abs = Math.round(internalDailyDemand / 60 * 10) / 10;
            capaContainer.spare_abs = Math.round((internalDailyDemand + internalAbsents < internalDailyCapacity ?
                internalDailyCapacity - internalDailyDemand - internalAbsents : 0) / 60 * 10) / 10;
            capaContainer.absent_abs = Math.round((internalAbsents - internalIntern) / 60 * 10) / 10;
            capaContainer.external_abs = Math.round(externalDailyDemand / 60 * 10) / 10;
            capaContainer.overload_abs = Math.round(containerOverload / 60 * 10) / 10;
            capaContainer.intern_abs = Math.round(internalIntern / 60 * 10) / 10;
            //todo: check this ...
            /*if (clearWeekend && this._calendarData.days.normal[i] === 0) {
                capaContainer.spare = 0;
            }*/

            capacities.push(capaContainer);
        }

        return capacities;
    }

    //normalizes the raw percentages with respect to the "largest" container
    private _getNormalizeValues = (capacities: Array<BarItemValues>) => {
        const normalized: Array<BarItemValues> = [];

        //normalize
        let maxSum = -1;
        //let maxIdx = -1;

        //get the position of the "largest" container
        capacities.forEach((item/*, index*/) => {
            const sum = item.absent + item.assignment + item.external + item.overload;
            if (sum > maxSum) {
                maxSum = sum;
                //maxIdx = index;
            }
        });

        //normalize all containers with respect to the "largest" container   
        if (maxSum === 0) {
            //there are no assignments in the date range -> initialize with empty values
            capacities.forEach(() => {
                normalized.push({
                    absent: 0,
                    assignment: 0,
                    external: 0,
                    overload: 0,
                    spare: 0,
                    intern: 0,
                    absent_abs: 0,
                    assignment_abs: 0,
                    external_abs: 0,
                    overload_abs: 0,
                    spare_abs: 0,
                    intern_abs: 0
                });
            });
        } else {
            capacities.forEach((item) => {
                const bar: BarItemValues = {
                    absent: Helper.normalizeSingleValue(item.absent, maxSum),
                    assignment: Helper.normalizeSingleValue(item.assignment, maxSum),
                    external: Helper.normalizeSingleValue(item.external, maxSum),
                    overload: Helper.normalizeSingleValue(item.overload, maxSum),
                    intern: Helper.normalizeSingleValue(item.intern, maxSum),
                    spare: 0,
                    absent_abs: item.absent_abs,
                    assignment_abs: item.assignment_abs,
                    external_abs: item.external_abs,
                    overload_abs: item.overload_abs,
                    spare_abs: item.spare_abs,
                    intern_abs: item.intern_abs
                };

                bar.spare = Math.max(0, 100 - (bar.absent + bar.assignment + bar.external + bar.overload));
                normalized.push(bar);
            });
        }

        return normalized;
    }

    private _getOverloadInfo = () => {
        const result: StringKeyDictionary<Array<number>> = {};

        for (let resKey in this._resources) {
            const resource = this._resources[resKey];
            if (resource.hasOverload) {
                //get the indices of the days when the resource has overload
                const daysWithOverload = resource.computed.over.map((v, i) => v > 0 ? i : -1).filter(v => v !== -1);
                if (this._scale === "Day") {
                    result[resKey] = daysWithOverload;
                } else if (this._scale === "Week") {
                    result[resKey] = Helper.unique(daysWithOverload.map(i => Math.floor(i / 7)));
                } else if (this._scale === "Month") {
                    const startYear = this._startDate.getFullYear();
                    const startMonth = this._startDate.getMonth();
                    result[resKey] = Helper.unique(daysWithOverload.map(i => {
                        const date = this._icuh.dates.addDays(this._startDate, i);
                        //convert the month to an index
                        //"jump" the months between the start and current years (+ 12 * (date.getFullYear() - startYear))
                        //the "start month" is at index 0 => need to substract the month (- startMonth)
                        //ex: startDate = 01.09.2018 => startMonth = 8, startYear = 2018
                        //case 1: date = 01.11.2019 => currentMonth = 10, currentYear = 2018 => index = 10 + 12 * (2018 - 2018) - 8 = 2
                        //case 2: date = 01.03.2019 => currentMonth = 2, currentYear = 2019 => index = 2 + 12 * (2019 - 2018) - 8 = 6 
                        return (date.getMonth() + 12 * (date.getFullYear() - startYear)) - startMonth;
                    }));
                }
            }
        }

        return result;
    }

    private _initAll = (data: CapacityInitData) => {
        this._initConstants();
        this._prepareResources(data.rosterDayInfos, data.resources);
        this._prepareAssignments(data.rosterDayInfos, data.assignments);
        this._computeForGroups();

        this._finalGroupedData = this._dailyGroupedData;

        if (data.scale === "Week") {
            this._finalGroupedData = this._getDailyGroupedDataAggregatedByWeek();
        } else if (data.scale === "Month") {
            this._finalGroupedData = this._getDailyGroupedDataAggregatedByMonth();
        }

        //get daily capacities
        let capacities = this._computeRawValues(this._finalGroupedData/*, true*/);
        if (data.scale === "Week" || data.scale === "Month") {
            capacities = this._computeRawValues(this._finalGroupedData/*, false*/);
        }
        this._aggregatedCapacities = capacities;

        this._normalizedValues = this._getNormalizeValues(capacities);

        this._previousOverloadData = this._currentOverloadData;
        this._currentOverloadData = this._getOverloadInfo();
    }

    private _initData = (data: CapacityInitData) => {
        this._days = data.days;
        this._units = data.units;
        this._startDate = data.startDate;
        this._scale = data.scale;
        this._ignoreUtilTravelTimes = data.ignoreUtilTravelTimes;
        this._initAll(data);
    }

    public computeCapacity = (data: CapacityInitData) => {
        //console.log("computeCapacity: ",data);
        this._initData(data);
    }

    public getComputedValues = (index: number) => {
        return {
            normalized: this._normalizedValues[index],
            raw: this._aggregatedCapacities[index]
        };
    }

    public getResourcesWithOverload = () => {
        return {
            previous: this._previousOverloadData,
            current: this._currentOverloadData
        };
    }
}

export const Helper = {
    getMonthsOffset: (startDate: Date, endDate: Date) => {
        if (startDate.getFullYear() == endDate.getFullYear() && startDate.getMonth() == endDate.getMonth()) {
            return 0;
        } else {
            let reference = startDate, target = endDate;
            if (reference > target) {
                reference = endDate;
                target = startDate;
            }

            return Math.max(0, (((target.getFullYear() - reference.getFullYear()) * 12) - (reference.getMonth() + 1) + target.getMonth())) + 1;
        }
    },
    clearDictionary: (dict: StringKeyDictionary<any>) => {
        for (let key in dict) delete dict[key];
    },
    getResourceType: (resId: string, tmpGroup: number): ResourceType => {
        if (resId.indexOf("g|") === 0) {
            return ResourceType.Container;
        } else {
            if (tmpGroup === 1 || tmpGroup === 2) {
                return ResourceType.External;
            } else {
                return ResourceType.Internal;
            }
        }
    },
    getOnesArray: (count: number) => {
        const result: Array<1> = [];
        for (let i = 0; i < count; i++) {
            result.push(1);
        }

        return result;
    },
    getZeroesArray: (count: number) => {
        const result: Array<0> = [];
        for (let i = 0; i < count; i++) {
            result.push(0);
        }

        return result;
    },
    normalizeSingleValue: (value: number, base: number) => {
        const raw = value * 100 / base;
        const rounded = Math.round(raw * 100) / 100;
        return isFinite(rounded) ? rounded : 0;
    },
    unique: (source: Array<number>) => {
        return source.filter((v, idx, s) => s.indexOf(v) === idx);
    },
    getContentArray: <T extends any>(content: T, count: number) => {
        const result: Array<any> = [];
        for (let i = 0; i < count; i++) {
            if (Array.isArray(content)) {
                result.push((content as any).splice());
            } else if (typeof content === "object") {
                result.push(JSON.parse(JSON.stringify(content)));
            } else {
                result.push(content);
            }
        }

        return result;
    }
}

export enum CapacityColorClasses {
    Absent = "capacity__color--absent",
    Assignment = "capacity__color--assignment",
    External = "capacity__color--external",
    Internal = "capacity__color--internal",
    Overload = "capacity__color--overload",
    Color = "capacity__color"
}

export interface CapacityDiagramProps {
    showDiagram: boolean;
    getData: () => CapacityDiagramPropsData;
    afterDiagramLoaded?: () => void;
}

interface CapacityDiagramPropsData {
    scheduler: DayPilot.Scheduler;
    startDate: Date;
    endDate: Date;
    scale: "Hour" | "Day" | "Week" | "Month";
    initialScrollPosition: number;
    translations: StringKeyDictionary<string>;
    renderScrollBarPadding: boolean;
    resources: Array<ResourcePlanningSchedulerResourceViewModel>;
    assignments: Array<ResourcePlanningSchedulerEventViewModel>;
    //freedays: Array<ResourcePlanningSchedulerFreedayViewModel>;
    settings: ResourcePlanningSchedulerCapacitySettings;
    //allWeekendDays: Array<WeekendDay>;
    settingsPlanningBoard: ResourcePlanningSchedulerSettingsPlanningBoardViewModel;
    ignoreUtilTravelTimes: boolean;
    rosterDayInfos: Array<RosterDayInfoViewModel>;
}

interface CapacityDiagramState {
    showPopUp: boolean;
}

interface DiagramInfoProps {
    scale: "Hour" | "Day" | "Week" | "Month";
    translations: StringKeyDictionary<string>;
}

interface DiagramInfoState {
    cursorX: number;
    cursorY: number;
    data: {
        date: Date;
    };
    bar: BarItemValues;
}

interface BarItemValues {
    absent: number;
    intern: number;
    assignment: number;
    external: number;
    overload: number;
    spare: number;
    absent_abs: number;
    intern_abs: number;
    assignment_abs: number;
    external_abs: number;
    overload_abs: number;
    spare_abs: number;
}

interface ResourceInfo {
    id: string;
    calendarId: number;
    groupId: number;
    type: ResourceType;
    assignments: Array<AssignmentInfo>;
    computed: {
        absent: Array<number>;
        demand: Array<number>;
        over: Array<number>;
        actualWork: Array<number>;
        intern: Array<number>;
    };
    hasOverload: boolean;
    model: ResourcePlanningSchedulerResourceViewModel;
}

enum ResourceType {
    Internal = 0, External = 1, Container = 2
}

interface AssignmentInfo {
    source: ResourcePlanningSchedulerEventViewModel;
    days: number;
    startDateIndex: number;
    type: AssignmentType;
}

interface CapacityInitData {
    days: number;
    units: number;
    startDate: Date;
    resources: Array<ResourcePlanningSchedulerResourceViewModel>;
    assignments: Array<ResourcePlanningSchedulerEventViewModel>;
    rosterDayInfos: Array<RosterDayInfoViewModel>;
    scale: "Hour" | "Day" | "Week" | "Month";
    ignoreUtilTravelTimes: boolean;
}

type CompleteResourceTypeArrays = {
    [ResourceType.Container]: Array<number>,
    [ResourceType.External]: Array<number>,
    [ResourceType.Internal]: Array<number>
}

type GroupedData = {
    availability: CompleteResourceTypeArrays,
    demand: CompleteResourceTypeArrays,
    overload: CompleteResourceTypeArrays,
    absent: CompleteResourceTypeArrays,
    intern: CompleteResourceTypeArrays,
    containerOverload: Array<number>
};

export enum CapacityRefreshMode {
    Recompute = 0, Reload = 1, ApplyFilter = 2
}

export enum ConsiderSkillMode {
    Off = 0, Exact = 1, Fuzzy = 2
}

export enum ConsiderGeoMode {
    Off = 0, Exact = 1, Fuzzy = 2
}
export interface FindAvailableResourcesConfig {
    percentage?: number;
    startDate?: Date;
    endDate?: Date;
    assignmentToDistributeId: string;
    considerFlags: boolean;
    considerGroup: boolean;
    considerMainGroup: boolean;
    considerSkills: ConsiderSkillMode;
    considerGeo: ConsiderGeoMode;
    considerSla: boolean;
    debugMode: boolean;
    grNrs: number[];
    ogrNrs: number[];
    ressNrs: string[];
}

export interface UnavailableReason {
    reasonCode: string;
    reason: string;
    date?: Date;
}

export interface ResourceWithSlots {
    ressNr: string;
    id: string,
    name: string,
    slots: Array<ResourceSlot>,
    unavailableReasons: Array<UnavailableReason>
}

export interface ResourceSlot {
    id: string;
    startDate?: Date | string;
    endDate?: Date | string;
    wayThere?: JourneyLegModel;
    wayBack?: JourneyLegModel;
    traveldataInfo?: TraveldataInfoModel;
    assignmentTimes?: AssignmentTimesModel;
    distance?: number;
    distanceKm?: number;
    nextAssignmentToBeChanged: boolean;
    nextAssignmentId?: string;
    nextAssignmentStartIst?: Date | string;
    prevAssignmentId?: string;
    prevAssignmentToBeChanged: boolean;
    prevAssignmentEndeIst?: Date | string;
    ressNr?: string;
    sourceAssignmentId?: string;
    skillsRequired: number;
    skillsProvided: number;
    missingSkills: Array<SkillRequirement>
}

export interface SkillRequirement {
    fid: number;
    skillGroup: string;
    rindex: number;
    skill: string;
    requirement: number;
    available: number;
}

export interface CapaReportInfo {
    von: Date;
    bis: Date;
    selResources: number;
    allResources: number;
    selGroups: number;
    allGroups: number;
    resources: StringKeyDictionary<ResourceInfo>;
    normalized: Array<BarItemValues>;
    aggregated: Array<BarItemValues>;
    scale: "Hour" | "Day" | "Week" | "Month";
}